/**
 * WordPress dependencies
 */
import { createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

/**
 * External dependencies
 *
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
});

/**
 * Internal dependencies
 */
import CourseRows from './components/CourseRows';
import { useLocalInstances } from '@hooks';

/**
 * Main Component
 */
function Main() {
	const { data, isPending, isError } = useLocalInstances({
		id: window.visitEduSettings.euneosId,
		apiUrl: window.visitEduSettings.apiBaseUrl,
	});

	return (
		<>
			<thead>
				<tr className="upcoming-instances__header">
					<th>Date</th>
					<th>Status</th>
					<th>Location</th>
					<th colSpan="2">Enrolment</th>
					<th>Catering fee</th>
				</tr>
			</thead>
			<tbody>
				<CourseRows
					data={data}
					isPending={isPending}
					isError={isError}
				/>
			</tbody>
		</>
	);
}

/**
 * Render block
 */
domReady(function () {
	createRoot(document.getElementById('upcoming-instances')).render(
		<QueryClientProvider client={queryClient}>
			<Main />
		</QueryClientProvider>
	);
});
